import { render, staticRenderFns } from "./ScanDataHistory.vue?vue&type=template&id=653e80ce&scoped=true"
import script from "./ScanDataHistory.vue?vue&type=script&lang=js"
export * from "./ScanDataHistory.vue?vue&type=script&lang=js"
import style0 from "./ScanDataHistory.vue?vue&type=style&index=0&id=653e80ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e80ce",
  null
  
)

export default component.exports